module.exports = __webpack_public_path__ + "img/antes_despues_236.de061933.png";